import { gql } from '@apollo/client'
import {
  AiIcon,
  BookIcon,
  BrandJusIa,
  CheckIcon,
  CheckRoundIcon,
  CloseIcon,
  FileSearchIcon,
  IconProps,
  InformationIcon,
  JusIaIcon,
  ScalesIcon,
  UserMultiIcon,
} from '@farol-ds/react'
import { IconTypeEnum } from '@jusbrasil-web/shared-apollo-client/types'

import { LockIcon_OfferLockIconFragment } from './__generated__/lock-icon.graphql'

const iconMap: Partial<Record<IconTypeEnum, React.ElementType>> = {
  [IconTypeEnum.Ai]: AiIcon,
  [IconTypeEnum.Book]: BookIcon,
  [IconTypeEnum.Check]: CheckIcon,
  [IconTypeEnum.CheckRound]: CheckRoundIcon,
  [IconTypeEnum.Close]: CloseIcon,
  [IconTypeEnum.FileSearch]: FileSearchIcon,
  [IconTypeEnum.JusIa]: JusIaIcon,
  [IconTypeEnum.JusIaBrand]: BrandJusIa,
  [IconTypeEnum.Info]: InformationIcon,
  [IconTypeEnum.Scales]: ScalesIcon,
  [IconTypeEnum.UserMulti]: UserMultiIcon,
}

interface LockIconProps {
  icon?: LockIcon_OfferLockIconFragment | null
  className?: string
  size?: IconProps['size']
}

export const LockIcon = ({ icon, className, size = 'md' }: LockIconProps) => {
  if (!icon || !icon.iconType) return null
  const { iconType, color } = icon

  const Icon = iconMap[iconType]

  if (!Icon) return null

  return (
    <Icon
      className={className}
      size={size}
      style={{ color: color || '' }}
      {...(iconType === IconTypeEnum.JusIaBrand ? { onlySymbol: true } : {})}
    />
  )
}

LockIcon.fragments = {
  icon: gql`
    fragment LockIcon_offerLockIcon on OfferLockIcon {
      iconType
      color
    }
  `,
}
